import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Tabs, Space } from 'antd/es';
import { TabsProps } from 'antd/es/tabs';
import withPcode from '../../components/hoc/withPcode';
import withNavbar from '../../components/hoc/with-navbar';
import Styles from './premiumReports.module.scss';
import Select from '../../components/ui/select';
import Dashboard from './dashboard/dashboard';
import { usePremiumSitesList } from '../../data/hooks/sites';
import noDataIcon from '../../assets/images/analytics/noData.svg';
import TEXT from './text';

// @flow
interface IPremiumReportsProps {
  app: {
    accountId: number,
    pCode: string
  };
}

const getPremiumSitesOptions = (sites) => {
  if (!sites) return [];

  const siteOptions = sites.properties.map(site => ({
    value: site.id,
    label: site.url,
    disabled: site.isDisabled
  }));
  const allOption = { value: 'all', label: 'All', disabled: false };
  return [allOption, ...siteOptions];
};

const { Option } = Select;

const PremiumReports = ({ app }: IPremiumReportsProps) => {
  const [tabId, setTabId] = useState('dashboard');
  const [propertyId, setPropertyId] = useState([]);

  const { isLoading: isSitesLoading, data: premiumSites } = usePremiumSitesList(app.pCode);
  const premiumSitesOptions = isSitesLoading ? [] : getPremiumSitesOptions(premiumSites);
  const allPremiumSiteIds = isSitesLoading ? [] : premiumSites.properties.map(site => site.id);

  const handleTabChange = (key) => {
    setTabId(key);
  };

  const tabItems: TabsProps = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      children: <Dashboard propertyId={propertyId} pCode={app.pCode} />
    },
    {
      key: 'analytics',
      label: 'Analytics',
      children: 'Content of analytics'
    }
  ];

  const handlePropertyChange = (values) => {
    if (values.includes('all')) {
      setPropertyId(allPremiumSiteIds);
    } else {
      setPropertyId(values);
    }
  };

  return (
    <>
      <section className={Styles.wrapper}>
        <section className={Styles.container}>
          <div className={Styles.propertySelection}>
            <Select
              required
              placeholder="Select properties"
              className={Styles.dropDown}
              loading={isSitesLoading}
              mode="multiple"
              onChange={handlePropertyChange}
              allowClear
              maxTagCount="responsive"
              value={propertyId}
            >
              {premiumSitesOptions
                && premiumSitesOptions.map(opt => (
                  <Option key={opt.value} value={opt.value} disabled={opt.disabled}>
                    {opt.label}
                  </Option>
                ))}
            </Select>
          </div>
          <main className={Styles.content}>
            {1 !== 0 ? (
              <Tabs
                size="small"
                onTabClick={handleTabChange}
                defaultActiveKey={tabId}
                className={Styles.tabs}
                items={tabItems}
              />
            ) : (
              <div className={Styles.noData}>
                <Space direction="vertical">
                  <div className={Styles.icon}>
                    <img src={noDataIcon} alt="No Data" />
                  </div>
                  <p>{TEXT.NO_DATA_LINE1}</p>
                  <p>{TEXT.NO_DATA_LINE2}</p>
                </Space>
              </div>
            )}
          </main>
        </section>
      </section>
    </>
  );
};

const MapStateToProps = ({ app }) => ({ app });
export default connect(MapStateToProps)(withPcode(withNavbar(PremiumReports)));
